import { SceneGroup, TextSceneNode } from "./scene";
class RowSceneGroup extends SceneGroup {
    onUpLayout() {
        let width = 0;
        let height = 0;
        for (const sceneNode of this._sceneNodes) {
            sceneNode.x = width;
            //console.log("row X: " + sceneNode.x);
            width += sceneNode.width;
            if (sceneNode.height > height) {
                height = sceneNode.height;
            }
        }
        for (const sceneNode of this._sceneNodes) {
            sceneNode.y = (height - sceneNode.height) / 2;
        }
        this._width = width;
        this._height = height;
    }
}
class CenterSceneGroup extends SceneGroup {
    calculateSize() { } //Don't do anything. Just keep width and height.
    onUpLayout() {
        for (const sceneNode of this._sceneNodes) {
            sceneNode.x = (this._width - sceneNode.width) * 0.5;
            sceneNode.y = (this._height - sceneNode.height) * 0.5;
        }
    }
}
class AxisSceneGroup extends SceneGroup {
    constructor(xStart, xCount, yStart, yCount, xWidth, yHeight, xName = null, yName = null) {
        super();
        //x axis
        for (let xIndex = xStart; xIndex < xCount; xIndex++) {
            const textSceneNode = new TextSceneNode(xIndex.toString(), "#839496", "6px serif", "center", "middle");
            textSceneNode.x = xIndex * xWidth;
            textSceneNode.y = 0;
            this.add(textSceneNode);
        }
        if (xName != null) {
            const textSceneNode = new TextSceneNode(xName, "#839496", "6px serif", "center", "middle");
            textSceneNode.x = -6;
            textSceneNode.y = 0;
            this.add(textSceneNode);
        }
        //y axis
        for (let yIndex = yStart; yIndex < yCount; yIndex++) {
            const textSceneNode = new TextSceneNode(yIndex.toString(), "#839496", "6px serif", "center", "middle");
            textSceneNode.x = 0;
            textSceneNode.y = yIndex * yHeight;
            this.add(textSceneNode);
        }
        if (yName != null) {
            const textSceneNode = new TextSceneNode(yName, "#839496", "6px serif", "center", "middle");
            textSceneNode.x = 0;
            textSceneNode.y = -6;
            this.add(textSceneNode);
        }
    }
}
export { AxisSceneGroup, CenterSceneGroup, RowSceneGroup };
